import React, { useEffect, useState } from 'react';
import Animate from '../Components/Animate';
import Spinner from '../Components/Spinner';
import { useUser } from '../context/userContext';
import NewUser from '../Components/NewUser';
import CommunitySlider from '../Components/Slides';
import TasksMenu from '../Components/TasksMenu';
import YourRewards from '../Components/YourRewards';
import { NavLink } from 'react-router-dom';

const AlphaDogs = () => {
  const { balance, loadingTwo, setLoadingTwo, checker, setChecker, loading } = useUser();
  const [checking, setChecking] = useState(false);
  const [welcome, setWelcome] = useState(true);
  const [animatedBalance, setAnimatedBalance] = useState(0);
  const [tgUser, setTgUser] = useState({
    name: 'First Name',
    username: 'telegram_id',
    photo_url: '/default-profile.png'
  });

  useEffect(() => {
    // টেলিগ্রাম ইউজার ডেটা লোড করুন
    if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
      const user = window.Telegram.WebApp.initDataUnsafe.user;
      setTgUser({
        name: user.first_name || 'First Name',
        username: user.username || 'telegram_id',
        photo_url: user.photo_url || '/default-profile.png'
      });
    }

    setTimeout(() => {
      setLoadingTwo(false);
    }, 2000);
  }, []);

  // Balance animation effect
  useEffect(() => {
    if (balance > 0) {
      let current = 0;
      const increment = balance / 10;
      const interval = setInterval(() => {
        current += increment;
        if (current >= balance) {
          current = balance;
          clearInterval(interval);
        }
        setAnimatedBalance(Math.floor(current));
      }, 100);
      
      return () => clearInterval(interval);
    }
  }, [balance]);

  const formatNumber = (num) => {
    return new Intl.NumberFormat().format(num);
  };

  const checkers = () => {
    setWelcome(false);
    setChecking(true);
  }

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Animate>
          <div className='w-full flex justify-center flex-col px-4'>
            <div id="refer" className="w-full h-screen pt-5 scroller space-y-3 overflow-y-auto pb-[180px]">
              {loadingTwo && (
                <div className="flex justify-center items-center h-full">
                  <div className="w-[50px] h-[50px] border-[6px] border-[#6c6c6c] mt-[-20%] border-dashed rounded-full animate-spin marco"></div>
                </div>
              )}

              <div className={`w-full overflow-hidden space-y-3 ${loadingTwo ? 'hidden' : 'block'}`}>
                {/* প্রোফাইল হেডার - টেলিগ্রাম ডেটা ব্যবহার করে */}
                <div className="flex justify-between items-center px-4 pt-2">
                  <div className="flex items-center gap-3">
                    <img 
                      src={tgUser.photo_url} 
                      alt="Profile" 
                      className="w-10 h-10 rounded-full object-cover border-2 border-[#1f2422]"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-profile.png';
                      }}
                    />
                    <div>
                      <h3 className="font-medium text-[16px] text-white">
                        {tgUser.name}
                      </h3>
                      <p className="text-[12px] text-gray-500">
                        ID: @{tgUser.username}
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <a href="https://t.me/voscoins" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#6c5ce7]">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.64 8.8C15.49 10.38 14.84 14.22 14.51 15.99C14.37 16.74 14.09 16.99 13.83 17.02C13.25 17.07 12.81 16.64 12.25 16.27C11.37 15.69 10.87 15.33 10.02 14.77C9.03 14.12 9.67 13.76 10.22 13.18C10.37 13.03 13.1 10.7 13.15 10.49C13.16 10.45 13.18 10.36 13.06 10.27C12.94 10.17 12.76 10.22 12.64 10.25C12.46 10.31 9.74 12.24 8.42 13.14C8.02 13.42 7.66 13.56 7.19 13.57C6.67 13.57 5.7 13.29 4.98 13.06C4.08 12.78 3.38 12.57 3.44 12.1C3.47 11.83 3.8 11.55 4.5 11.25C8.93 9.36 11.86 8.09 14.7 6.38C15.6 5.85 16.5 5.58 16.95 5.62C17.49 5.67 18.65 6.77 18.48 8.05" fill="currentColor"/>
                      </svg>
                    </a>
                    <a href="https://x.com/voscoins" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#6c5ce7]">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.244 2.25H21.552L14.171 10.51L22.706 21.75H16.042L10.916 14.933L5.043 21.75H1.736L9.688 12.915L1.5 2.25H8.328L12.983 8.481L18.244 2.25ZM17.083 19.77H18.916L7.044 4.126H5.078L17.083 19.77Z" fill="currentColor"/>
                      </svg>
                    </a>
                    <a href="https://youtube.com/@voscoins?si=vTc2Y-VGxs8TW-Ao" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#6c5ce7]">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.615 3.184C16.011 2.938 7.984 2.939 4.385 3.184C0.488 3.45 0.029 5.804 0 12C0.029 18.185 0.484 20.549 4.385 20.816C7.985 21.061 16.011 21.062 19.615 20.816C23.512 20.55 23.971 18.196 24 12C23.971 5.815 23.516 3.451 19.615 3.184ZM9 16V8L17 12L9 16Z" fill="currentColor"/>
                      </svg>
                    </a>
                  </div>
                </div>

                {/* ব্যালেন্স সেকশন */}
                <div className='w-full flex justify-center bg-gradient-to-r from-[#071414] to-[#070f0c] rounded-[12px] p-6'>
                  <div className='w-full flex flex-col items-center'>
                    <h4 className='font-semibold text-[32px] text-white'>
                      {formatNumber(animatedBalance || balance)}
                    </h4>
                    <p className='text-white pb-4'>
                      Voscoin
                    </p>
                    <NavLink 
                      to='/airdrop' 
                      className="bg-[#0088cc] flex h-10 rounded-[7px] items-center justify-center py-1 px-[72px] space-x-2 border border-[#0077b3] shadow-md hover:bg-[#0077b3] transition-colors"
                      >
                        <img 
                          src='/wallet.png' 
                          alt="connect"
                          className="w-4 h-4"
                        />
                        
                        <div className="text-sm font-medium text-white whitespace-nowrap">
                        Wallet Details →
                        </div>
                    </NavLink>
                  </div>
                </div>

                <CommunitySlider/>

                <div className='w-full flex flex-col'>
                  <TasksMenu/>
                  <YourRewards/>
                </div>
              </div>

              {checker && (
                <div className="fixed inset-0 z-40 taskbg flex justify-center items-center">
                  <div className="w-full h-full taskbg flex flex-col items-center px-4">
                    {welcome && (
                      <div className='w-full h-full relative pb-24 flex items-center justify-center flex-col space-y-3'>
                        <div className='absolute w-[180px] h-[180px]'>
                          <img src='/stars.gif' alt='stars' className='w-full'/>
                        </div>
                        <div className='absolute bottom-10 flex flex-col w-full justify-center items-center space-y-5'>
                          <p className='w-full text-center max-w-[20em]'>
                            Welcome to {process.env.REACT_APP_PROJECT_NAME_SMALL}!<br/> Start mining {process.env.REACT_APP_PROJECT_NAME_SMALL} tokens today!
                          </p>
                          <button 
                            onClick={balance > 0 ? () => setChecker(false) : checkers} 
                            className='w-full py-3 rounded-[8px] font-semibold px-3 flex items-center justify-center text-center bg-btn'
                          >
                            Let's go!
                          </button>
                        </div>
                      </div>
                    )}
                    {checking && <NewUser setChecker={setChecker}/>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Animate>
      )}
    </>
  );
};

export default AlphaDogs;